/**
 * SDK 兼容类型层 — 提供 @osp/osp-web3-login 中被广泛使用的类型定义
 *
 * 目的：允许消费方从此处导入类型，而非依赖已废弃的 SDK 包
 * 生命周期：随 T7.4 完成后，各消费方逐步迁移到更语义化的命名
 */

/** Firebase 社交登录提供商 */
export type SocialLoginProvider = "GOOGLE" | "TWITTER" | "APPLE";

/** 支持的登录类型（含 Google One Tap） */
export type Web3LoginSupportedType = SocialLoginProvider | "GOOGLE_ONE_TAP";

export enum LoginType {
  Social = 1,
  Web3Auth = 1,
  OSP_EMAIL = 2,
}

export interface IOspLoginChain {
  ospAddress: string;
  sessionAddress?: string;
  status: "ACTIVE" | "INACTIVE";
  profileId: string;
  chainId: number;
}

export interface IOspLoginInfo {
  eoaAddress?: string;
  ospOwnerId?: string;
  sessionAddress?: string;
  appId?: string;
  chains?: IOspLoginChain[];
  [key: string]: unknown;
}

export interface IOspCredentials {
  accessToken?: string;
  refreshToken?: string;
}

export interface IOspCredentialsStorage {
  getCredentials(): Promise<IOspCredentials | null>;
  setCredentials(credentials: IOspCredentials): Promise<void>;
  setIdToken(idToken: string): Promise<void>;
  reset?(): Promise<void>;
}

export interface IOspAuthModule {
  readonly storage: IOspCredentialsStorage;
  authenticate(
    eoa_address: string,
    signature: string,
    options?: Record<string, string> & { issue_platform?: string },
  ): Promise<{ access_token?: string; refresh_token?: string }>;
  refreshToken(
    check?: boolean,
    expTime?: number,
  ): Promise<IOspCredentials | null>;
  getLoginInfo(): Promise<IOspLoginInfo | null | undefined>;
  idToken(): Promise<{ id_token?: string }>;
  logout(): Promise<void>;
}
